import { Component, OnInit, ViewChild, TemplateRef, Input, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { SectorService } from 'app/client-core/services/sector.service';
import { BsModalRef } from 'ngx-bootstrap';
import { TacticService } from 'app/client-core/services/tactic.service';
import { ProgramDetailsTactic, ProgramDetailsDto } from 'app/client-core/dtos/program-details';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import { ValidationMessage } from 'app/validation';

const $ = jQuery;

@Component({
    selector: 'program-details-print-modal',
    templateUrl: './create.modal.component.html',
    styleUrls: [
        './create.modal.scss'
    ]
})
export class PrintModalComponent implements OnInit, AfterViewInit {
    ready: boolean;
    @Input() programDetailsDto: ProgramDetailsDto = {} as ProgramDetailsDto;
    public validationMessages: ValidationMessage;

    submitting: boolean;
    submitted: boolean;

    exportAsConfig: ExportAsConfig = {
        type: 'pdf', // the type you want to download
        elementId: 'page-print', // the id of html/table element
    }

    constructor(
        public modalRef: BsModalRef,
        private exportAsService: ExportAsService
    ) {

    }

    ngOnInit() {
        this.ready = true;
    }

    ngAfterViewInit(): void {
        $("#modallogo img").attr('src', $("#logo img").attr('src'));
    }

    close(): void {
        this.modalRef.hide();
    }

    getTotal(tactic: ProgramDetailsTactic) {
        let totalAtl = 0;
        let totalBtl = 0;
        let total = 0;
        tactic.programDetailsTacticComponent.forEach(c => {
            totalAtl += c.estimatedAtl;
            totalBtl += c.estimatedBtl;
            total += totalAtl + totalBtl;
        });
        return {
            totalAtl: totalAtl,
            totalBtl: totalBtl,
            total: total
        }
    }

    getTotalInvoice(tactic: ProgramDetailsTactic) {
        let totalinvoiceAtl = 0;
        let totalinvoiceBtl = 0;
        let totalinvoice = 0;
        tactic.programDetailsTacticComponent.forEach(c => {
            totalinvoiceAtl += c.invoiceAtl;
            totalinvoiceBtl += c.invoiceBtl;
            totalinvoice += c.invoiceAtl + c.invoiceBtl;
        });
        return {
            totalAtl: totalinvoiceAtl,
            totalBtl: totalinvoiceBtl,
            total: totalinvoice
        }
    }

    getAllTotals() {
        var estimatedAtl = 0;
        var estimatedBtl = 0;
        var estimatedTotal = 0;

        var invoiceAtl = 0;
        var invoiceBtl = 0;
        var invoiceTotal = 0;

        if (this.programDetailsDto && this.programDetailsDto.programDetailsTactic) {
            this.programDetailsDto.programDetailsTactic.forEach(t => {
                let totalEstimated = this.getTotal(t);
                let totalInvoice = this.getTotalInvoice(t);

                estimatedAtl += totalEstimated.totalAtl;
                estimatedBtl += totalEstimated.totalBtl;
                estimatedTotal += totalEstimated.total;

                invoiceAtl += totalInvoice.totalAtl;
                invoiceBtl += totalInvoice.totalBtl;
                invoiceTotal += totalInvoice.total;
            });
        }

        return {
            estimatedAtl: estimatedAtl,
            estimatedBtl: estimatedBtl,
            estimatedTotal: estimatedTotal,
            invoiceAtl: invoiceAtl,
            invoiceBtl: invoiceBtl,
            invoiceTotal: invoiceTotal,
        }
    }

    getFundingTotals() {
        const totals = {
            estimatedAtl: 0,
            estimatedBtl: 0,
            estimatedTotal: 0,
            invoicedAtl: 0,
            invoicedBtl: 0,
            invoicedTotal: 0,
            fundingPercentage: 0
        }
        if (this.programDetailsDto.prgramDetailsFundingSources) {
            this.programDetailsDto.prgramDetailsFundingSources.forEach(f => {
                const esatl = parseFloat(this.replaceFormats(f.estimatedAtl));
                const esbtl = parseFloat(this.replaceFormats(f.estimatedBtl));
                totals.estimatedAtl += esatl;
                totals.estimatedBtl += esbtl;
                totals.estimatedTotal += esatl + esbtl;
                const inatl = parseFloat(this.replaceFormats(f.invoicedAtl));
                const inbtl = parseFloat(this.replaceFormats(f.invoicedBtl));
                totals.invoicedAtl += inatl;
                totals.invoicedBtl += inbtl;
                totals.invoicedTotal += inatl + inbtl;
                totals.fundingPercentage += parseFloat(this.replaceFormats(f.estimatedFundingPercentage))
            });
        }
        return totals;
    }

    replaceFormats(value) {
        if (!value) {
            return 0;
        }
        return value;
    }

    exportToPdf() {
        this.exportAsService.save(this.exportAsConfig, `program_details_${this.programDetailsDto.id}`).subscribe(response => {
            console.log(response);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/print/create.modal.component.ts